import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { isObject } from 'lodash-es';
import { tryJSONStringify } from 'src/util/json';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClipboardService } from '../clipboard.service';
import { MessageParams } from '../operation-alert.service';

@Component({
  selector: 'tcs-operation-error-alert-details',
  templateUrl: './operation-error-alert-details.component.html',
  styleUrls: ['./operation-error-alert-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationErrorAlertDetailsComponent {
  public copyTooltip = 'Click to copy activity ID and error details';
  public readonly details: string | null;
  public operationIdCtrl: UntypedFormControl;
  constructor(
    private _clipboard: ClipboardService,
    @Inject(MAT_DIALOG_DATA)
    public params: {
      operationId: string;
    } & MessageParams,
  ) {
    this.operationIdCtrl = new UntypedFormControl(params.operationId);
    this.details = isObject(params.details)
      ? tryJSONStringify(params.details)
      : (params.details as string | null);
  }

  get renderSyntax() {
    return isObject(this.params.details) && this.details != null;
  }

  public copy() {
    let toCopy = `=== Activity ID === \n`;
    toCopy += this.params.operationId + '\n\n';
    toCopy += `=== Details === \n`;
    toCopy += this.details;

    this._clipboard.copy(toCopy, {
      message: 'Error details copied to clipboard',
    });
  }

  public copyActivityId(event: MouseEvent) {
    // sometimes the event is triggered without a user's click
    if (event.isTrusted) {
      this._clipboard.copy(this.operationIdCtrl.value, {
        message: 'Activity ID copied to clipboard',
      });
    }
  }
}
